import { Box, Button, Fab, Grid, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AlertMessage } from "../messages/AlertMessage";
import { useLocation } from "react-router";
import { FryerEntry } from "./FryerEntry";
import AddIcon from '@mui/icons-material/Add';

const Fryer = () =>
{  
    const { state } = useLocation();
    const [fryers, setFryers] = useState([]);

    const loadAllFryers = () => {
        const requestOptions = {
            method: 'GET'
        };
        
        fetch('/api/fryers', requestOptions)
        .then(r => r.json())
        .then(res => setFryers(res))
        .catch(err => console.error(err));
    };
    
    useEffect(() => {
        loadAllFryers();
    }, []);

    const handleChangeSearch = (event) => {
        const requestOptions = {
            method: 'GET'
        };
        const val = event.target.value;
        if(val === ''){
            loadAllFryers();
        }else{
            fetch('/api/search_fryer?searchString='+val, requestOptions)
            .then(r => r.json())
            .then(res => {
                setFryers(res);
            })
            .catch(err => console.error(err));
        }
        
    };

    return(
        <Box sx={{flexGrow: 1, marginTop: '10px !important'}}>
           <Box sx={{ overflow: "auto" }}>
              <Box sx={{ width: "100%", boxSizing: 'border-box', display: "table", tableLayout: "fixed" }}>
                    <AlertMessage severity={'success'} message={state?.message} />
                    <Stack direction="row" spacing={2} sx={{ flexGrow: 1, margin: '20px', alignItems: 'center' }}>
                        <Typography variant="h6" component="div">
                        Fryer
                        </Typography>
                        <Fab href="/fryer/add" size="medium" color="primary" aria-label="add">
                        <AddIcon />
                        </Fab>
                    </Stack>
                    <TextField label="Suche" onChange={(event) => handleChangeSearch(event)}/>
                    <Grid
                        container
                        direction="row"
                        sx={{
                            marginTop: '20px',
                            alignItems: "stretch",
                        }} 
                        spacing={4}
                    >
                        {fryers?.length === 0 && 
                        (<Box sx={{ marginTop: '20px !important', marginBottom: '20px !important' }}>
                            <Typography sx={{marginLeft: '20px !important'}} variant="body2">
                            Leider konnten wir keine Einträge finden, die deinem Fryer entsprechen. 
                            Versuche es mit einem anderen Suchbegriff oder erstelle selbst einen neuen Eintrag.
                            </Typography>
                            <Button className="custom-button-root" href="/fryer/add">Neuen Eintrag erstellen</Button>
                        </Box>)}
                        {fryers.map(f => <FryerEntry
                            id={f?.id}
                            name={f?.name}
                            hersteller={f?.hersteller} 
                            handleChangeSearch={handleChangeSearch}
                        />)}
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};

export default Fryer;